import { PlusIcon } from './PlusIcon';

/**
 * author: Google
 * id 2DE4F8E6-F25C-4FCA-8405-109FA8918B78
 * name plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus.svg
 * tags
 * - Math 
 */
export const AddIcon = PlusIcon;
export default AddIcon